import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../../apiconfig";
import HeaderPage from "./HeaderFooter/header";
import FooterPage from "./HeaderFooter/footer";
import { useLocation } from "react-router-dom";

function LandingPage() {


    const navigate = useNavigate();
    const [notices, setNotices] = useState([]);
    const [alertData, setAlertData] = useState(null);
    useEffect(() => {
        if (alertData) {
            const timer = setTimeout(() => setAlertData(null), 5000);
            return () => clearTimeout(timer);
        }
    }, [alertData]);

    const location = useLocation();

    useEffect(() => {
        if (location.state?.message) {
            setAlertData({
                message: location.state.message,
                id: Date.now()
            });
        }
    }, [location.state]);

    useEffect(() => {
        fetchNotices();
    }, []);

    const fetchNotices = async () => {

        try {

            const response = await fetch(
                `${API_BASE_URL}/API/Student/GET_NOTICES`
            );

            if (!response.ok) return;

            const data = await response.json();

            console.log("notice list:", data);

            setNotices(data);

        } catch (err) {

            console.error("Failed to fetch notices", err);

        }
    };

    const openFile = (base64Data, fileName) => {

        let mimeType = "application/pdf";

        if (
            fileName.toLowerCase().endsWith(".jpg") ||
            fileName.toLowerCase().endsWith(".jpeg")
        ) {
            mimeType = "image/jpeg";
        }

        if (fileName.toLowerCase().endsWith(".png")) {
            mimeType = "image/png";
        }

        const byteCharacters = atob(base64Data);

        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0;i < byteCharacters.length;i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);

        const blob = new Blob([byteArray], { type: mimeType });

        const fileURL = URL.createObjectURL(blob);

        window.open(fileURL, "_blank");
    };
    return (
        <>
            <style>{`
        .main-section {
          text-align: center;
          padding: 30px 15px;
          font-family: 'Poppins', sans-serif;
        }
		
		@keyframes zoomFade {
		  from {
		    opacity: 0;
		    transform: scale(0.92);
		  }
		  to {
		    opacity: 1;
		    transform: scale(1);
		  }
		}

		.btn-container {
		  display: flex;
		  justify-content: center;
		  gap: 25px;
		  flex-wrap: wrap;
		  margin-bottom: 30px;
		}

		/* 🔥 Base button */
		.main-btn {
		  position: relative;
		  padding: 14px 28px;
		  font-size: 15px;
		  font-weight: 600;
		  border: none;
		  border-radius: 40px;
		  cursor: pointer;
		  color: #fff;
		  overflow: hidden;
		  transition: all 0.3s ease;
		  letter-spacing: 0.5px;
		}

		/* 🔵 Registration Button */
		.reg-btn {
		  background: linear-gradient(135deg, #2f55d4, #5a7cff);
		  box-shadow: 0 4px 12px rgba(47, 85, 212, 0.3);
		}

		/* 🟢 Login Button */
		.login-btn {
		  background: linear-gradient(135deg, #28a745, #4cd964);
		  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
		}

		/* ✨ Hover Effect */
		.main-btn:hover {
		  transform: translateY(-3px) scale(1.02);
		  box-shadow: 0 6px 18px rgba(0,0,0,0.2);
		}

		/* 🔥 Glow animation */
		.main-btn::before {
		  content: "";
		  position: absolute;
		  width: 120%;
		  height: 120%;
		  top: -10%;
		  left: -10%;
		  background: rgba(255,255,255,0.2);
		  transform: rotate(25deg);
		  opacity: 0;
		  transition: 0.4s;
		}

		.main-btn:hover::before {
		  opacity: 1;
		  transform: rotate(25deg) translateX(60%);
		}

		/* 💡 Active click effect */
		.main-btn:active {
		  transform: scale(0.96);
		}
        /* NOTICE BOX */
        .notice-box {
          max-width: 700px;
          margin: auto;
          background: #fff;
          border-left: 4px solid #ff9800;
          padding: 18px;
          border-radius: 6px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.08);
          text-align: left;
        }

        .notice-title {
          font-size: 16px;
          font-weight: 700;
          color: #1a237e;
          margin-bottom: 10px;
        }

        .notice-item {
          font-size: 14px;
          margin: 6px 0;
          color: #333;
        }

        .notice-item a {
          color: #2f55d4;
          text-decoration: none;
          font-weight: 600;
        }

        .notice-item a:hover {
          text-decoration: underline;
        }

        /* Responsive */
        @media (max-width: 600px) {
          .main-btn {
            width: 80%;
          }
        }
      `}</style>

            <HeaderPage />

            <div className="main-section">

                {/* 🔹 Buttons */}
                <div className="btn-container">
                    {/*<button
                        className="main-btn reg-btn"
                        onClick={() => navigate("/Registration")}
                    >
                        📝 Registration
                    </button>*/}

                    <button
                        className="main-btn reg-btn"
                        onClick={() =>
                            setAlertData({
                                message: "Registration Closed ❌",
                                id: Date.now()
                            })
                        }
                    >
                        📝 Registration
                    </button>

                    <button
                        className="main-btn login-btn"
                        onClick={() => navigate("/Login")}>
                        🔐 Login
                    </button>
                </div>
                {/* 🔹 Notice Box */}
                <div className="notice-box">

                    <div className="notice-title">
                        📌 NOTICE
                    </div>

                    {notices.map((item, index) => (

                        <div className="notice-item" key={index}>

                            <button
                                onClick={() => openFile(item.file, item.title)}
                                style={{
                                    width: "100%",
                                    padding: "12px 16px",
                                    background: "#ffffff",
                                    border: "1px solid #e2e8f0",
                                    borderRadius: "10px",
                                    cursor: "pointer",
                                    textAlign: "left",
                                    fontSize: "14px",
                                    fontWeight: "600",
                                    color: "#1e293b",
                                    marginBottom: "10px",
                                    boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                                    transition: "all 0.2s ease"
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.background = "#f8fafc";
                                    e.currentTarget.style.transform = "translateY(-2px)";
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.background = "#ffffff";
                                    e.currentTarget.style.transform = "translateY(0px)";
                                }}
                            >
                                📄 {item.title.replace(/\.[^/.]+$/, "")}
                            </button>

                        </div>

                    ))}

                </div>

                {alertData && (
                    <div className={`custom-alert ${alertData.type === "success" ? "success" : "error"}`} key={alertData.id}>
                        <span className="alert-icon">⚠️</span>
                        {alertData.message}
                    </div>
                )}

            </div>

            <FooterPage />
        </>
    );
}

export default LandingPage;